<div
    class="navbar-option"
    (mouseenter)="showTooltip = true"
    (mouseleave)="showTooltip = false"
>
    <div class="dropdown">
        <div class="dropdown-toggle" data-toggle="dropdown">
            <object
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'profile'"
            ></object>
            <div class="username" [title]="displayName">
                {{ displayName }}
            </div>
        </div>

        <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" (click)="logout()"
                >{{ "logout" | lang }}
                <img
                    appImageSelector
                    alt="mt-image"
                    imageKey="logout"
                    imageType="icon"
            /></a>
        </div>

        <label
            *ngIf="showTooltip"
            [attr.tooltip]="'profile' | lang"
            tooltip-position="bottom"
            class="label-tooltip"
        ></label>
    </div>
</div>
